// src/api/website-api/web-product.js
import axios from "axios";

// List & detail are the same vendor endpoint
const WEB_PRODUCT_DETAIL_API =
  `${process.env.REACT_APP_API_POS_WITH_WEBSITE}/api/vendor/products`;

const getLang = () => localStorage.getItem("lang") || "en";

const getLanguageHeaders = () => {
  const lang = getLang();
  return {
    "Accept-Language": lang,              // "en" or "ar"
    "Language-ID": lang === "ar" ? 4 : 1, // 4 for Arabic, 1 for English
  };
};

export const fetchWebProducts = async ({
  page = 1,
  pagelimit = 12,
  search = "",
  categoryId,
  sku = "",
  status,
} = {}) => {
  const token =
    localStorage.getItem("token") || localStorage.getItem("authToken");
  const storeId = localStorage.getItem("storeId");

  const headers = {
    ...getLanguageHeaders(),
  };

  // 🔐 add auth + store
  if (token) headers.Authorization = `Bearer ${token}`;
  if (storeId) headers["Store-ID"] = storeId;

  const params = { page, pagelimit, channel: 2 };
  if (status != null) params.status = status;

  // Combine search and sku into one search query if backend supports it
  const searchTerms = [search, sku].filter(Boolean).join(" ");
  if (searchTerms) params.search = searchTerms;
  if (categoryId && categoryId !== "all") params.category_id = categoryId;

  const res = await axios.get(WEB_PRODUCT_DETAIL_API, { headers, params });

  const responseData = res.data;

  // Handle nested response: { success: true, data: { count, next, previous, results } }
  const paginationData = responseData?.data ?? responseData;
  
  const count = paginationData?.count ?? 0;
  const next = paginationData?.next ?? null;
  const previous = paginationData?.previous ?? null;

  const products = Array.isArray(paginationData?.results)
    ? paginationData.results
    : Array.isArray(responseData?.results)
    ? responseData.results
    : Array.isArray(responseData)
    ? responseData
    : [];

  const totalPages = Math.ceil(count / pagelimit) || 1;

  console.log("🛰️ Raw product API data:", responseData);
  console.log("✅ Parsed products:", products);
  console.log(`📊 Pagination: count=${count}, totalPages=${totalPages}`);

  return {
    products,
    count,
    totalPages,
    next,
    previous,
  };
};

/**
 * Fetch single product by ID
 */
export const fetchWebProductById = async (productId) => {
  const token =
    localStorage.getItem("token") || localStorage.getItem("authToken");
  const storeId = localStorage.getItem("storeId") || 693877; // or 189460

  const headers = {
    ...getLanguageHeaders(),
    "Store-ID": storeId,
  };

  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await axios.get(`${WEB_PRODUCT_DETAIL_API}/${productId}`, {
    headers,
    params: { channel: 2 },
  });

  const p = res.data;

  return {
    ...p,
    _id: String(p.product_id || p.id || p._id),
    Product_Name:
      p.name || p.meta_title || p.model || (p.sku ? `SKU ${p.sku}` : "Unnamed"),
    CategoryId: p.categories?.length ? String(p.categories[0]) : "uncategorized",
    Price: Number(p.price ?? 0),
    Qty: Number(p.quantity ?? 0),
    image: p.image,
  };
};
